import { customFormatDate } from "./coworking";

export const dataLayerStep1 = (locationType, howOften, howOftenDays, homeLocation, teamSize) => {
   const totalDays = howOften == "week" ? howOftenDays * 4.3 : howOftenDays;
   const locationBox = locationData.find((loc) => loc.id == homeLocation);
   const homeLocationLabel = locationBox?.title || "Unknown";

   const eventData = {
      event: "co_work_stage_1",
      workers: teamSize,
      days: Math.ceil(totalDays),
      access_type: locationType,
      location: homeLocationLabel,
   };

   if (typeof dataLayer !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push(eventData);
   } else {
      console.log("dataLayer not defined, logging event to console:");
   }
   console.log(eventData);
};

export const dataLayerStep2 = (cart) => {
   let extras = {};
   if (
      cart?.coworking_extras_bolt_ons &&
      Object.entries(cart.coworking_extras_bolt_ons).length > 0
   ) {
      let count = 1;
      for (const key in cart.coworking_extras_bolt_ons) {
         if (cart.coworking_extras_bolt_ons.hasOwnProperty(key)) {
            extras[`extra ${count}`] = cart.coworking_extras_bolt_ons[key].name;
            count++;
         }
      }
   }
   else {
      extras = { "extra": "No extras added" }
   }

   const eventData = {
      event: "co_work_stage_2",
      ...extras,
   };

   if (typeof dataLayer !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push(eventData);
   } else {
      console.log("dataLayer not defined, logging event to console:");
   }
   console.log(eventData);
};

export const dataLayerStep3 = (startDate, planType, paymentOption, firstMonthPrice) => {
   const startDateFormatted = customFormatDate(startDate);

   const eventData = {
      event: "co_work_stage_3",
      type: planType,
      member_start_date: startDateFormatted,
      period: paymentOption,
      value: firstMonthPrice,
      currency: "gbp",
   };

   if (typeof dataLayer !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push(eventData);
   } else {
      console.log("dataLayer not defined, logging event to console:");
   }
   console.log(eventData);
};

export const dataLayerStep4 = () => {
   const eventData = {
      event: "co_work_stage_4",
   };
   if (typeof dataLayer !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push(eventData);
   } else {
      console.log("dataLayer not defined, logging event to console:");
   }
   console.log(eventData);
};

export const dataLayerStep5 = (planType) => {
   const eventData = {
      event: "co_work_stage_5",
      type: planType + "_reg_complete"
   };

   if (typeof dataLayer !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push(eventData);
   } else {
      console.log("dataLayer not defined, logging event to console:");
   }
   console.log(eventData);
};
